import { useDispatch, useSelector } from 'react-redux'
import {
  selectProdDetailValues,
  updateHasExistingModels,
  updateProductOwner,
} from '../../../../../features/createCertificate/createCertificateSlice'
import CustomerNameLookupDialog from '../../../../../shared/model-search/customer-name-lookup/CustomerNameLookupDialog'
import { useEffect } from 'react'

const CertificateCustomerNameLookup = (props: any) => {
  const { isLookupShow, setIsLookupShow, formValues, setFormValues, listener, setListener, closeSignal } = props
  const productDetails = useSelector(selectProdDetailValues)
  const dispatch = useDispatch()

  const onHide = () => {
    setIsLookupShow(false)
  }

  useEffect(() => {
    if (closeSignal)
      setIsLookupShow(false)
  }, [closeSignal])

  const handlePartySiteChange = (e: any) => {
    const currentValue = formValues[listener.field]

    if (listener.field === 'certificate_ownerReference' && currentValue !== e) {
      const { modelList } = productDetails

      if (modelList?.length > 0) {
        dispatch(updateHasExistingModels(true))
        dispatch(updateProductOwner(e))
        return
      }
    }

    if (e) {
      setFormValues((prevState: any) => {
        let newValue

        // CLEANING UP THE CURRENT VALUE
        if (Array.isArray(prevState[listener.field])) {
          newValue = structuredClone(prevState[listener.field])

          if (newValue.length > 0) {
            newValue[listener.index] = ''
          } else newValue = []
        } else {
          newValue = ''
        }

        const newState = {
          ...prevState,
          [listener.field]: newValue,
        }

        return newState
      })

      setListener({
        field: listener.field,
        value: e,
        index: listener.index,
      })
    }

    setIsLookupShow(false)
  }

  return (
    <CustomerNameLookupDialog
      displayCustomerNameLookup={isLookupShow}
      onHideCustomerNameLookup={onHide}
      setPartySiteNumber={handlePartySiteChange}
      autoHideOnSelect={false}
    />
  )
}

export default CertificateCustomerNameLookup
